import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DownloadCampaignCSVRequest {
  token: string;
  startDate: string;
  endDate: string;
}

const downloadVATransactionsCSV = async ({
  token,
  startDate,
  endDate,
}: DownloadCampaignCSVRequest) => {
  try {
    const body: Record<string, string> = {
      startDate,
      endDate,
    };

    const response = await axios.post(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/download-va-transactions-csv`,
      body,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default downloadVATransactionsCSV;
